import { GetChallengeResponse } from '../types';

/**
 * Canonical visibility rule for challenge special offers.
 *
 * Legacy field `should_show_special_offers` actually means
 * "hide special offers until check-in".
 */
export function shouldRevealSpecialOffer(options: {
    challenge?: Pick<GetChallengeResponse, 'should_show_special_offers' | 'hide_special_offers_until_checkin'> | null;
    isCheckedIn: boolean;
    isGuide: boolean;
}): boolean {
    const { challenge, isCheckedIn, isGuide } = options;
    if (isGuide) return true;

    // Prefer canonical field; fall back to legacy misnamed field
    const hideUntilCheckin = challenge?.hide_special_offers_until_checkin
        ?? challenge?.should_show_special_offers === true;
    return !hideUntilCheckin || isCheckedIn;
}